var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg48X48Officenew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5680C1;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.67,29.16c-4.38,5.98-8.81,11.9-13.24,17.83c-0.28,0.38-0.7,0.68-1.06,1h-0.66 c-0.39-0.34-0.87-0.61-1.17-1.02C18.2,41.16,13.89,35.32,9.54,29.5c-1.84-2.48-3.09-5.2-3.58-8.25c-0.58-3.66-0.12-7.18,1.42-10.56 c1.68-3.66,4.28-6.48,7.79-8.4c3.62-1.99,7.48-2.7,11.59-2.07c3.32,0.51,6.29,1.83,8.86,3.97c3.05,2.55,5.12,5.73,6.07,9.61 C43.06,19.38,42.06,24.53,38.67,29.16z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,34.55c-8.89,0-16.12-7.23-16.12-16.12S15.11,2.32,24,2.32s16.11,7.23,16.11,16.12S32.89,34.55,24,34.55z  M24,3.44c-8.26,0-14.99,6.72-14.99,14.99S15.73,33.42,24,33.42c8.26,0,14.99-6.72,14.99-14.99S32.26,3.44,24,3.44z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.34,8.79H21.78c-0.38,0-0.69,0.35-0.69,0.78v18.06c0,0.43,0.31,0.78,0.69,0.78h10.56 c0.38,0,0.69-0.35,0.69-0.78V9.57C33.03,9.14,32.72,8.79,32.34,8.79z M25.73,21.36v1.84h-1.9v-1.84H25.73z M25.73,17.68v1.84h-1.9 v-1.84H25.73z M25.73,13.99v1.84h-1.9v-1.84H25.73z M30.29,21.36v1.84h-1.9v-1.84H30.29z M30.29,17.68v1.84h-1.9v-1.84H30.29z  M30.29,13.99v1.84h-1.9v-1.84H30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.69,18.02h-6.31c-0.23,0-0.42,0.19-0.42,0.41V28c0,0.23,0.19,0.41,0.42,0.41h6.31 c0.23,0,0.42-0.19,0.42-0.41v-9.57C22.11,18.2,21.92,18.02,21.69,18.02z M17.75,24.68v0.98h-1.14v-0.98H17.75z M17.75,22.73v0.98 h-1.14v-0.98H17.75z M17.75,20.77v0.98h-1.14v-0.98H17.75z M20.47,24.68v0.98h-1.14v-0.98H20.47z M20.47,22.73v0.98h-1.14v-0.98 H20.47z M20.47,20.77v0.98h-1.14v-0.98H20.47z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg48X48Officenew);
export default __webpack_public_path__ + "static/media/48x48 office new.d3554f7c64d59157dd2101e48bef6bf3.svg";
export { ForwardRef as ReactComponent };